import React, { Component } from 'react';
import { APP_URL_API } from '../../setup/configs'
import Input from '../../ui/input/Input';
import Modal from '../../ui/modal/Modal';
import axios from 'axios';

export default class Members extends Component {
    constructor(props) {
        super(props)

        this.state = {
          value: '',
          showModal: false,
          showAlertModal: false,
          accept: false,
          locked: false
        }
    }

    componentDidMount() {
        this.setState({
            value: this.props.membershipsCount,
            locked: this.props.membershipLockedAt ? true : false
        })
    }

    onHandleUnlockMembership() {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const membership_id = this.props.membershipId;
        const url = APP_URL_API + 'memberships/' + membership_id + '/unlock';

        const data = {};
        data._method = "patch";

        this.serverRequest =
            axios
                .post(url, data, {headers: config})
                .then(function(result) {
                }.bind(this))
    }

    addMembers = (count, year) => {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const organizationID = this.props.organizationId;
        const url = APP_URL_API + 'organizations/'+ organizationID +'/memberships';

        let data = {};
        data.count = parseInt(count);
        data.year = parseInt(year);

        this.serverRequest =
            axios
                .put(url, data, {headers: config})
                .then(function(response) {
                })
    }

    onChange = (e) => {
        const value = e.target.value;
        if(e.target.type==="checkbox") {
            this.setState({
                [e.target.name]: e.target.checked
            })
        } else {
            this.setState({
                value: value
            }, this.props.onHandleAddMembersCount(this.props.year, value))
        }
    }

    onSubmit = (e) => {
        e.preventDefault();
        if(this.props.user.type==="user" && (!this.state.accept || this.state.value === "")) {
            this.setState({
                    modalText: 'Du skal udfylde medlemstal og godkende betingelserne',
                    showAlertModal: true,
                    showModal: false
            });
        } else if (this.props.user.type==="admin" && this.state.value === "") {
            this.setState({
                    modalText: 'Du skal udfylde medlemstal',
                    showAlertModal: true,
                    showModal: false
            });
        } else {
            this.setState({
                showModal: false,
                locked: true
            }, this.addMembers(this.state.value, this.props.year))
        }
    }

    _handleUnLock = (e) => {
        e.preventDefault;
        this.setState({
            locked: false
        }, this.onHandleUnlockMembership())
    }

    onToggleModal = () => {
        if(this.state.showModal) {
            this.setState({
                showModal: false
            });
        } else {
            this.setState({
                showModal: true
            })
        }
    }

    render() {
        const yearPlusOne = parseInt(this.props.year) + 1;
        const placeholder = "Antal medlemmer pr. 1/1 " + yearPlusOne+ ":";

        return (
            <div>
                <div className="memberfield__wrapper">
                
                <div className="flex flex-col">
                    <div className="text-sm">{placeholder}</div>
                    <Input type="text" value={this.state.value} maxLength="6" minWidth="200px" name="members" onChange={(e) => this.onChange(e)} disabled={this.state.locked} />
                    <ShowButton locked={this.state.locked} onToggleModal={this.onToggleModal} user={this.props.user} />
                </div>
                
                {
                this.props.user.type==="admin" && <a onClick={(e) => { if (window.confirm('Er du sikker på at du vil åbne op for enhedens mulighed for at indberette medlemstal?')) this._handleUnLock(e)}} style={{cursor: this.state.locked ? 'pointer' : ''}}>
                    {this.state.locked ?
                            <img alt="Lås op" src="/images/assets/låsblå.svg" title="Lås op" />
                             : ''}
                </a>
                }
            
                </div>
                <Modal visible={this.state.showModal}>
                    <h4>Indberet medlemstal</h4>
                    <div style={{marginTop: '1em'}}>
                        Feltet låses efter indberetning, og det kan ikke ændres. Bemærk, at oplysningerne om medlemstal alene er tilgængelige for By-, Land- og Kirkeministeriet og ikke vises på Trossamfundsregistrets hjemmeside.
                    </div>
                    <div style={{marginTop: '1em'}}>
                        { this.props.user.type==="admin" ?
                            <div>Der foreligger dokumentation i ESDH-systemet for, at trossamfundet/menigheden har anmodet By-, Land- og Kirkeministeriet om at indberette på trossamfundets/menighedens vegne.</div>
                        :
                            <label style={{fontSize: '1em', padding: 0, margin: 0}}>
                            <input type="checkbox" name="accept" onChange={this.onChange} checked={this.state.accept} />
                            Jeg erklærer hermed på tro og love, at de indberettede oplysninger er korrekte og i overensstemmelse med de gældende regler for anerkendte trossamfund, samt at jeg i henhold til § 7, stk. 2, nr. 4, i lov nr. 1533 af 19. december 2017 om trossamfund uden for folkekirken er berettiget til på trossamfundets/menighedens vegne at foretage indberetningen.
                            </label>
                        }
                    </div>
                    <div style={{marginTop: '1em'}}>
                        <button type="button" className="button" onClick={() => this.onToggleModal()}>Luk</button>
                        <button type="button" className="button" onClick={this.onSubmit}>Gem</button>
                    </div>
                </Modal>
                <Modal visible={this.state.showAlertModal}>
                    <p>{this.state.modalText}</p>
                    <div style={{marginTop: '3em', textAlign: 'right', minWidth: '400px'}}>
                        <button type="button" className="button" onClick={() => this.setState({showAlertModal: false, showModal: true})}>Ok</button>
                    </div>
                </Modal>
            </div>
        )
    }
}

const ShowButton = (props) => {
    if(props.locked) {
        return(
            <div>
                {props.user.type==="user" && <img alt="Låst" src="/images/assets/låsblå.svg" title="Låst" style={{padding: '.25em 1em'}}/>}
            </div>
        )
    } else {
        return(<div><button type="button" className="button" onClick={props.onToggleModal}>Indberet</button></div>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/reports/Members.js